/**
 * Created by TF on 2018/6/20
 */

import {LoginUsers, Users} from "./data/user";
import {Dynamic, Project} from "./data/userCenter";


let _Users = Users;
let _userCenter = Dynamic;

export default {

  init (mock) {


    mock.onGet('/success').reply(200, {
      msg: 'success'
    });

    // mock error request
    mock.onGet('/error').reply(500, {
      msg: 'failure'
    });

    // 登录
    mock.onPost('/login').reply(arg => {
      let {username, password} = JSON.parse(arg.data);
      return new Promise((resolve, reject) => {
        let user = null;
        setTimeout(() => {
          let hasUser = LoginUsers.some(u => {
            if (u.username === username && u.password === password) {
              user = JSON.parse(JSON.stringify(u));
              delete user.password;
              return true
            }
          });

          if (hasUser) {
            resolve([200, {code: 200, msg: '请求成功', user}])
          } else {
            resolve([200, {code: 500, msg: '账号或密码错误'}])
          }
        }, 1000)
      })
    });

    mock.onPost('/user/profile').reply(function (arg) {
      let {name, email} = JSON.parse(arg.data);
      return new Promise((resolve, reject) => {
        let user = LoginUsers[0];
        user.name = name;
        user.email = email;
        resolve([200, {code: 200, msg: '请求成功', user}])
      })
    });

    /**
     * 用户列表
     */
    mock.onGet('/user/list').reply(config => {
      let {page, name} = config.params;
      let mockUsers = _Users.filter(user => {
        if (name && user.name.indexOf(name) === -1) return false;
        return true
      });
      let total = mockUsers.length;
      mockUsers = mockUsers.filter((u, index) => index < 10 * page && index >= 10 * (page - 1));
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve([200, {
            total: total,
            users: mockUsers
          }])
        }, 500)
      })
    });

    /**
     * 添加用户
     */
    mock.onGet('/user/add').reply(config => {
      let {name, age, sex, addr, birth} = config.params;
      _Users.push({
        name: name,
        age: age,
        sex: sex,
        addr: addr,
        birth: birth
      });
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve([200, {
            code: 200,
            msg: '新增成功'
          }])
        }, 500)
      })
    });

    /**
     * 修改用户
     */
    mock.onGet('/user/edit').reply(config => {
      let {id, name, age, sex, addr, birth} = config.params;
      _Users.some(u => {
        if (u.id === id) {
          u.name = name;
          u.age = age;
          u.sex = sex;
          u.addr = addr;
          u.birth = birth;
          return true
        }
      });
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve([200, {
            code: 200,
            msg: '编辑成功'
          }])
        }, 500)
      })
    });

    /**
     * 删除用户
     */
    mock.onGet('/user/delete').reply(config => {
      let {id} = config.params;
      _Users = _Users.filter(b => b.id !== id);
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve([200, {
            code: 200,
            msg: '删除成功'
          }])
        }, 500)
      })
    });

    /**
     * 批量删除用户
     */
    mock.onGet('/user/batchdelete').reply(config => {
      let {ids} = config.params;
      ids = ids.split(',');
      _Users = _Users.filter(u => !ids.includes(u.id));
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve([200, {
            code: 200,
            msg: '删除成功'
          }])
        }, 500)
      })
    });


    // ======================================= Rectifications ============================================================
    mock.onGet('/dynamic/list').reply(config => {
      let {name} = config.params;
      let mockDynamic = _userCenter.filter(rectification => {
        if (name && rectification.name.indexOf(name) === -1) return false;
        return true
      });
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve([200, {
            datas: mockDynamic
          }])
        }, 500)
      })
    });

    // 删除用户
    mock.onGet('/rectification/delete').reply(config => {
      let {id} = config.params;
      _userCenter = _userCenter.filter(b => b.id !== id);
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve([200, {
            code: 200,
            msg: '删除成功'
          }])
        }, 500)
      })
    });

    // 编辑图书
    mock.onGet('/rectification/edit').reply(config => {
      let {id, name, deadlineStart, deadlineEnd, source, type, zzgk, checkResult, fxwtjcl, summarize, fileUrl} = config.params;
      _userCenter.some(u => {
        if (u.id === id) {
          u.name = name;
          u.deadlineStart = deadlineStart;
          u.deadlineEnd = deadlineEnd;
          u.source = source;
          u.type = type;
          u.zzgk = zzgk;
          u.checkResult = checkResult;
          u.fxwtjcl = fxwtjcl;
          u.summarize = summarize;
          u.fileUrl = fileUrl;
          return true
        }
      });

      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve([200, {
            code: 200,
            msg: '编辑成功'
          }])
        }, 500)
      })
    });

    // 批量删除图书
    mock.onGet('/rectification/batchdelete').reply(config => {
      let {ids} = config.params;
      ids = ids.split(',');
      _userCenter = _userCenter.filter(u => !ids.includes(u.id));
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve([200, {
            code: 200,
            msg: '删除成功'
          }])
        }, 500)
      })
    });

    // 新增图书
    mock.onGet('/rectification/add').reply(config => {
      let {name, deadlineStart, deadlineEnd, source, type, zzgk, checkResult, fxwtjcl, summarize, fileUrl} = config.params;
      _userCenter.push({
        name: name,
        deadlineStart: deadlineStart,
        deadlineEnd: deadlineEnd,
        source: source,
        type: type,
        zzgk: zzgk,
        checkResult: checkResult,
        fxwtjcl: fxwtjcl,
        summarize: summarize,
        fileUrl: fileUrl
      });
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve([200, {
            code: 200,
            msg: '新增成功'
          }])
        }, 500)
      })
    });

    mock.onGet('/rectification/list').reply(config => {
      let {name} = config.params;
      let mockUsers = _Others.filter(user => {
        if (name && user.name.indexOf(name) === -1) return false;
        return true
      });
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve([200, {
            userCenter: mockUsers
          }])
        }, 500)
      })
    });


  }
}



// WEBPACK FOOTER //
// ./src/mock/mock.js